<div class="modal-backdrop" [@modalFadeIn]>
  <div class="modal-container">
    <div class="modal">
      <!-- Modal Header -->
      <div class="modal-header">
        <h3 class="modal-title">Fazer Upgrade de Plano</h3>
        <button mat-icon-button mat-dialog-close aria-label="Fechar modal">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="modal-body">
        <!-- Informação do Plano Atual -->
        <section class="current-plan-info">
          <div class="info-label">Plano Atual</div>
          <div class="plan-summary">
            <div class="plan-name">{{ data.plan.name }}</div>
            <div class="plan-value">{{ formatCurrency(data.plan.finalTotal || 0) }}/mês</div>
          </div>
        </section>

        <mat-divider></mat-divider>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="isLoading()">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Carregando planos disponíveis...</p>
        </div>

        <!-- Lista de Pacotes Disponíveis -->
        <section class="packages-section" *ngIf="!isLoading()">
          <h3 class="section-title">Escolha seu novo plano</h3>
          
          <!-- Empty State -->
          <div class="empty-state" *ngIf="availablePackages().length === 0">
            <mat-icon>info_outline</mat-icon>
            <p>Não há planos superiores disponíveis para upgrade no momento.</p>
          </div>

          <!-- Package Cards -->
          <div class="packages-grid" *ngIf="availablePackages().length > 0">
            <div 
              *ngFor="let pkg of availablePackages()" 
              class="package-card"
              [class.selected]="selectedPackage()?.id === pkg.id"
              (click)="selectPackage(pkg)">
              
              <div class="package-header">
                <h4 class="package-name">{{ pkg.name }}</h4>
                <mat-icon class="check-icon" *ngIf="selectedPackage()?.id === pkg.id">check_circle</mat-icon>
              </div>
              
              <div class="package-price">
                <span class="price-value">{{ formatCurrency(calculatePackageTotal(pkg)) }}</span>
                <span class="price-period">/mês</span>
              </div>

              <div class="package-description" *ngIf="pkg.description">
                {{ pkg.description }}
              </div>

              <div class="package-items" *ngIf="pkg.items && pkg.items.length > 0">
                <div class="items-label">Inclui:</div>
                <ul class="items-list">
                  <li *ngFor="let item of pkg.items">
                    <mat-icon>check</mat-icon>
                    <span>{{ item.product?.name || 'Item' }} ({{ item.quantity }}x)</span>
                  </li>
                </ul>
              </div>

              <div class="package-discounts" *ngIf="pkg.discounts && pkg.discounts.length > 0">
                <mat-chip color="accent" class="discount-chip">
                  <mat-icon>local_offer</mat-icon>
                  Com desconto
                </mat-chip>
              </div>
            </div>
          </div>
        </section>

        <!-- Informações Importantes -->
        <section class="info-section" *ngIf="!isLoading() && availablePackages().length > 0">
          <div class="alert alert-info">
            <mat-icon>info_outline</mat-icon>
            <div>
              <strong>Como funciona o upgrade:</strong>
              <ul>
                <li>As parcelas futuras do plano atual serão canceladas</li>
                <li>Um novo pagamento parcelado em 12x será criado</li>
                <li>A primeira cobrança será 30 dias após o último pagamento</li>
                <li>Você terá acesso imediato às novas funcionalidades</li>
              </ul>
            </div>
          </div>
        </section>
      </mat-dialog-content>

      <!-- Modal Actions -->
      <mat-dialog-actions class="modal-footer">
        <button mat-button (click)="close()">Cancelar</button>
        <button 
          mat-flat-button 
          color="primary"
          [disabled]="!selectedPackage() || isLoading()"
          (click)="confirmSelection()">
          <mat-icon>arrow_forward</mat-icon>
          Continuar
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
